import commonUtil from '../../utils/commonUtil';
import { showLabelTextQueryString } from '../../utils/clientConstant';

// Please update pagename in labelPageNameConfig files.
const labelPageNameFile = require('../../utils/config/labelPageNameConfig');

export const LABELS_LOAD = 'LABELS_LOAD';
export const LABELS_LOAD_SUCCESS = 'LABELS_LOAD_SUCCESS';
export const LABELS_LOAD_FAIL = 'LABELS_LOAD_FAIL';

export function isLablesLoaded(globalState) {
  return globalState.labels && globalState.labels.loaded;
}
export function loadLables() {
  const _labelInput = {};
  _labelInput.brand = commonUtil.getBrand();
  _labelInput.channel = commonUtil.getChannel();
  // _labelInput.pageNames = labelPageNameFile.labelPageNameConfig;
  return {
    types: [LABELS_LOAD, LABELS_LOAD_SUCCESS, LABELS_LOAD_FAIL],
    promise: (client) =>
      client.get('/api/labels?' + commonUtil.objectToQueryParams(_labelInput)),
  };
}

export function helthCheck() {
  const _labelInput = {};
  _labelInput.brand = commonUtil.getBrand();
  _labelInput.channel = commonUtil.getChannel();
  _labelInput.pageNames = ['createLogin'];

  return {
    types: [LABELS_LOAD, LABELS_LOAD_SUCCESS, LABELS_LOAD_FAIL],
    promise: (client) =>
      client.post(
        '/api/labelsHelthCheck?' + showLabelTextQueryString + '=true',
        {
          data: _labelInput,
        },
      ),
  };
}
